import {
  TrackActionIdentifiers,
  TrackActionScopes,
} from '@shared/track-user-actions/track-user-actions.component.model';

export interface Command {
  title?: string;
  command: Function | string;
  active?: boolean;
  activeTitle?: string;
  onActiveCommand?: Function | string;
  onActiveCommandIcon?: string;
  className?: string | Function;
  icon?: string;
  warningIcon?: string;
  isSingleObjectAction?: boolean;
  isNestedActionOnly?: boolean;
  isVisible?: Function;
  visible?: boolean;
  toolTip?: string;
  isDisabled?: boolean;
  actionScope?: TrackActionScopes;
  actionIdentifier?: TrackActionIdentifiers;
  isVisibleBySelectedCommand?: Function;
}

export interface CommandSet {
  defaults?: Command[]; // present all the time
  mixed?: Command[]; // only when mixed selection
  leafs?: Command[]; // only when leafs selected
  containers?: Command[]; // only when containers
}

export const isCommandAction = element => {
  if (element.classList && element.classList.contains('command-action')) {
    return true;
  } else if (element.parentNode != null) {
    return isCommandAction(element.parentNode);
  }
  return false;
};
